export const environment = {
  production: true,
  APIEndpoint: '/api',
};
